export interface PastaVooRapido {
	pasta: string;
	total: number;
	removidas: string[];
}

export interface ResultadoVooRapido {
	mantidas: File[];
	pastas: PastaVooRapido[];
}

/**
 * Voo rápido: em cada pasta de imagens remove a 2ª e a penúltima imagem
 * (ordenadas por nome). A primeira e a última nunca são removidas, então
 * pastas com menos de 3 imagens ficam intactas.
 */
export function filtrarImagensVooRapido(files: File[]): ResultadoVooRapido {
	const porPasta = new Map<string, File[]>();
	for (const file of files) {
		const path = file.webkitRelativePath || file.name;
		const pasta = path.includes('/') ? path.slice(0, path.lastIndexOf('/')) : '';
		const arquivos = porPasta.get(pasta);
		if (arquivos) arquivos.push(file);
		else porPasta.set(pasta, [file]);
	}

	const removidas = new Set<File>();
	const pastas: PastaVooRapido[] = [];
	for (const [pasta, arquivos] of porPasta) {
		const ordenados = [...arquivos].sort((a, b) =>
			a.name.localeCompare(b.name, undefined, {
				numeric: true,
				sensitivity: 'base',
			}),
		);
		const ultimo = ordenados.length - 1;
		const indices = new Set(
			[1, ultimo - 1].filter((i) => i > 0 && i < ultimo),
		);

		const nomes: string[] = [];
		for (const i of indices) {
			removidas.add(ordenados[i]);
			nomes.push(ordenados[i].name);
		}
		pastas.push({ pasta, total: arquivos.length, removidas: nomes });
	}

	return {
		mantidas: files.filter((f) => !removidas.has(f)),
		pastas,
	};
}

export function logVooRapido({ mantidas, pastas }: ResultadoVooRapido): void {
	const totalRemovidas = pastas.reduce((acc, p) => acc + p.removidas.length, 0);

	console.group(
		`[Voo rápido] ${totalRemovidas} imagem(ns) removida(s) em ${pastas.length} pasta(s) — ${mantidas.length} serão enviadas`,
	);
	for (const { pasta, total, removidas } of pastas) {
		console.log(
			`${pasta || '(raiz)'} (${total} imagens) → removidas: ${
				removidas.length ? removidas.join(', ') : 'nenhuma (menos de 3 imagens)'
			}`,
		);
	}
	console.groupEnd();
}
